// npm packages
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// project imports
import { TechnologyCard } from "./TechnologyCard";

// conffig
import { projects } from "../config/technologies";

import "animate.css";

import "./Technologies.css"

export const Technologies = () => {
  const { t } = useTranslation();

  return (
    <section className="technologies" id="technologies">
      <Container>
        <Row>
          <Col size={12}>
          <div
                  className= "animate__animated animate__fadeIn"
                >
                  <h2>{t("technologies.title")}</h2>

                  <Container fluid>
                  {/* <Row className="row-cols-4 justify-content-center gap-5 "> */}
                  <Row className="row-cols-4 justify-content-center gap-3 gap-sm-5 ">
                      {projects.map((project, index) => (
                        <Col key={index} className="w-auto p-0 m-0">
                          <TechnologyCard key={index} {...project} />
                        </Col>
                      ))}
                    </Row>
                  </Container>
                </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
